module.exports = __webpack_public_path__ + "static/media/STRDL-ETH.dafe70e5.png";